import React from "react"
import { useDrag } from "muuri-react"
import moment from 'moment'
import _ from 'lodash'
import { formatAddress, getTimestamp, getTimestamp2, trimName } from '../utils'

export const Pumpfun = ({ color, width, height, title, tokenEvents }) => {

  const isDragging = useDrag()
  const shadow = isDragging ? "shadow" : ""

  console.log('tokenEvents pumpfun', tokenEvents)






  return (
    <div className={`item h${height} w${width} ${color} ${shadow}`}>
      <div className="handle">
        <span className="header">Pumpfun Launches</span> 
        <img src="./dragIcon.png" className="dragIcon" />
      </div>
      <div className="item-content">
        {
          !_.isNil(tokenEvents) && tokenEvents.length > 0
          ? tokenEvents.filter(x => x.platform === 'pumpfun').map(tokenEvent =>
<div key={tokenEvent.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  {/* Left Side: Name and Address */}
  <div>

                                      <img 
  src={'./solana.png'}
  style={{ width: '20px', position: 'relative', top: '5px', paddingRight: '5px' }} 

/>

    <span style={{ color: 'rgb(0, 218, 255)' }}>{trimName(tokenEvent.name.trim())}</span>
    <span style={{ color: '#7c83f7', marginLeft: '8px' }}>{formatAddress(tokenEvent.address)}</span>
  </div>


  {/* Right Side: Icons and Timestamp */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>


    <span className="ts" style={{ minWidth: '30px', textAlign: 'right' }}>
      {getTimestamp2(tokenEvent.timestamp)}
    </span>
  </div>
</div>
)
          : 'Loading Token Events'
        }
      </div>
    </div>
  )
}